<template>
  <div>
    <div>
      <Navigation />
    </div>

    <div class="profile-page-wrapper">
      <!-- Left Sidebar -->
      <aside class="profile-sidebar">
        <div class="sidebar-avatar-wrap">
          <div class="avatar-container" @click="isEditing && triggerFileInput()" :class="{ editable: isEditing }">
            <img :src="previewImageUrl || savedImageUrl || defaultImage" class="sidebar-avatar" />
            <div v-if="isEditing" class="avatar-edit-overlay">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </div>
          </div>
          <router-link
            v-if="accountType === 'business' && userSlug"
            :to="'/business/' + userSlug"
            class="sidebar-username sidebar-username--link"
          >{{ username }}</router-link>
          <h2 v-else class="sidebar-username">{{ username }}</h2>
          <span class="sidebar-account-badge" :class="accountType">{{ accountType === 'business' ? '🏢 Business' : '👤 Individual' }}</span>
        </div>
        <div class="sidebar-info-list">
          <div class="sidebar-info-item" v-if="firstName || lastName">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/></svg>
            <span>{{ firstName }} {{ lastName }}</span>
          </div>
          <div class="sidebar-info-item" v-if="email">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" points="22,6 12,13 2,6"/></svg>
            <span class="contact-line">
              <span>{{ email }}</span>
              <!-- <span class="verification-badge" :class="emailVerified ? 'verified' : 'unverified'" title="Email Verification Status">
                <template v-if="emailVerified">
                 
                  <svg width="20" height="20" viewBox="0 0 48 48"><rect x="4" y="12" width="40" height="28" rx="6" fill="#F44336"/><polygon points="4,12 24,30 44,12" fill="#fff" opacity="0.5"/><circle cx="36" cy="20" r="7" fill="#fff"/><path d="M33 20l3 3 5-5" stroke="#4CAF50" stroke-width="2" fill="none"/></svg>
                </template>
                <template v-else>
                
                  <svg width="20" height="20" viewBox="0 0 48 48"><rect x="4" y="12" width="40" height="28" rx="6" fill="#BDBDBD"/><polygon points="4,12 24,30 44,12" fill="#fff" opacity="0.5"/><circle cx="36" cy="20" r="7" fill="#fff"/><path d="M33 18l6 6M39 18l-6 6" stroke="#F44336" stroke-width="2" fill="none"/></svg>
                </template>
              </span> -->
                <span class="verification-badge" :class="emailVerified ? 'verified' : 'unverified'">
                {{ emailVerified ? 'Email Verified' : 'Email Unverified' }}
                 </span>
            </span>
          </div>
          <div class="sidebar-info-item" v-if="mobile">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            <span class="contact-line">
              <span>{{ selectedCountryCode }} {{ mobile }}</span>
             <span class="verification-badge" :class="phoneVerified ? 'verified' : 'unverified'">
                {{ phoneVerified ? 'Phone Verified' : 'Phone Unverified' }}
                </span>
            </span>
          </div>
          <div class="sidebar-info-item" v-if="defaultLocation">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3" stroke="#6b7280" stroke-width="1.8"/></svg>
            <span>{{ defaultLocation }}</span>
          </div>
          <div class="sidebar-info-item" v-if="businessName">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline stroke="#6b7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" points="9 22 9 12 15 12 15 22"/></svg>
            <span>{{ businessName }}</span>
          </div>
        </div>
        <button class="sidebar-edit-btn" v-if="showEdit" @click="onClickedit">
          <svg width="15" height="15" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          Edit Profile
        </button>
        <!-- Subscription Plan Section -->
        <div class="sidebar-plan-section">
          <span class="sidebar-plan-label">Your Plan</span>
          <div class="sidebar-plan-badge-row">
            <span class="sidebar-plan-badge" :class="'plan--' + subscriptionPlan">
              {{ subscriptionPlan === 'free' ? 'Free (Growth)' : subscriptionPlan === 'premium' ? 'Premium' : 'Business' }}
            </span>
          </div>
          <div class="sidebar-plan-usage" v-if="subscriptionInfo">
            <span v-if="subscriptionInfo.postsLimit !== 'Unlimited'">{{ subscriptionInfo.postsUsed || 0 }}/{{ subscriptionInfo.postsLimit }} posts this month</span>
            <span v-else>Unlimited posts</span>
          </div>
          <div class="sidebar-plan-usage" v-if="subscriptionInfo && subscriptionInfo.featuredLimit > 0">
            <span>{{ subscriptionInfo.featuredUsed || 0 }}/{{ subscriptionInfo.featuredLimit }} featured this month</span>
          </div>
          <div class="sidebar-plan-usage" v-if="subscriptionInfo">
            <span>{{ subscriptionInfo.imagesPerPost }} images per post</span>
          </div>
          <div class="sidebar-plan-cancel-notice" v-if="subscriptionInfo && subscriptionInfo.cancelAtPeriodEnd">
            <span class="sidebar-plan-cancel-notice-text">
              <strong>Premium cancellation scheduled:</strong><br>
              Your premium benefits remain active until <b>{{ formatPeriodEnd(subscriptionInfo.currentPeriodEnd) }}</b>.<br>
              After this date, your account will switch to Free.
            </span>
          </div>
          <button class="sidebar-upgrade-btn" v-if="subscriptionPlan === 'free'" @click="goToPricing">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            Upgrade Plan
          </button>
          <button class="sidebar-manage-btn" v-else @click="manageSubscription">
            Manage Plan
          </button>
          <router-link to="/analytics" class="sidebar-analytics-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            View Analytics
          </router-link>
        </div>

        <router-link
          v-if="accountType === 'business' && userSlug"
          :to="'/business/' + userSlug"
          class="sidebar-view-profile-link"
        >
          <svg width="15" height="15" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="15 3 21 3 21 9"/><line stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" x1="10" y1="14" x2="21" y2="3"/></svg>
          View Business Profile
        </router-link>
      </aside>

      <!-- Right Form Panel -->
      <div class="profile-form-panel" :class="{ 'is-editing': isEditing }">
        <div class="form-panel-header">
          <h3>Profile Information</h3>
          <p class="form-panel-subtitle">{{ isEditing ? 'Edit your profile details below' : 'Keep your details up to date' }}</p>
          <span v-if="isEditing" class="edit-mode-badge">Editing</span>
        </div>
        <form class="profile-form" :class="{ 'form-scrollable': isEditing }">

        <!-- Banner Customization — Top of page -->
        <div v-if="accountType === 'business'" class="form-group banner-top-section">
          <label>Profile Banner</label>
          <p class="banner-hint">Customize the banner on your public business profile page.</p>

          <!-- Banner preview -->
          <div class="banner-preview" :style="bannerPreviewStyle">
            <div v-if="!bannerImagePreview && !bannerImage" class="banner-preview-pattern"></div>
            <span class="banner-preview-label">Banner Preview</span>
          </div>

          <!-- Color presets -->
          <div class="banner-color-section">
            <span class="banner-section-label">Choose a color</span>
            <div class="banner-color-grid">
              <button
                v-for="(gradient, idx) in bannerGradients"
                :key="'grad-' + idx"
                type="button"
                class="banner-color-swatch"
                :class="{ selected: bannerColor === gradient.value && !bannerImagePreview && !bannerImage }"
                :style="{ background: gradient.value }"
                :title="gradient.name"
                :disabled="!isEditing"
                @click="selectBannerColor(gradient.value)"
              ></button>
            </div>
          </div>

          <!-- Or upload image -->
          <div class="banner-upload-section">
            <span class="banner-section-label">Or upload an image</span>
            <div
              class="banner-upload-zone"
              :class="{ 'drag-active': bannerDragOver, disabled: !isEditing }"
              @click="isEditing && $refs.bannerFileInput.click()"
              @dragover.prevent="isEditing && (bannerDragOver = true)"
              @dragleave.prevent="bannerDragOver = false"
              @drop.prevent="isEditing && handleBannerDrop($event)"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9b8e82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
              <span v-if="bannerImagePreview || bannerImage">Image selected - click to change</span>
              <span v-else>Click to upload or drag image</span>
              <span class="banner-upload-hint">Recommended: 1200x300px, JPG or PNG</span>
            </div>
            <button
              v-if="bannerImagePreview || bannerImage"
              type="button"
              class="banner-remove-btn"
              :disabled="!isEditing"
              @click="removeBannerImage"
            >Remove image</button>
          </div>
          <input
            type="file"
            ref="bannerFileInput"
            style="display: none"
            accept="image/jpeg,image/png,image/webp"
            @change="handleBannerFileSelect"
          />
        </div>

        <div class="form-group">
          <label class="account-type-label">Account Type</label>
          <div class="account-type-toggle-simple">
            <button
              type="button"
              :class="['toggle-simple', accountType === 'individual' ? 'active' : '']"
              @click="setAccountType('individual')"
              :disabled="!isEditing"
            >
              Individual
            </button>
            <button
              type="button"
              :class="['toggle-simple', accountType === 'business' ? 'active' : '']"
              @click="setAccountType('business')"
              :disabled="!isEditing"
            >
              Business
            </button>
          </div>
        </div>

        <div class="row">
          <div class="form-group-name">
            <label>First Name</label>
            <input
              type="text"
              placeholder="Enter your First Name"
              v-model="firstName"
              class=""
              :disabled="!isEditing"
            />
          </div>
          <div class="form-group-name">
            <label>Last Name</label>
            <input
              type="text"
              v-model="lastName"
              placeholder="Enter your Last Name"
              :disabled="!isEditing"
            />
          </div>
        </div>

        <!-- Business Profile Fields (conditionally shown) -->
        <template v-if="accountType === 'business'">
          <div class="form-group">
            <label>Business Name</label>
            <input
              type="text"
              v-model="businessName"
              placeholder="Enter your business name"
              :disabled="!isEditing"
            />
          </div>


<div class="form-group">
  <label>Services</label>
  <div class="services-box">
    <div class="all-services-pills">
      <span
        v-for="service in servicesList"
        :key="service"
        :class="['service-pill', { selected: selectedServices.includes(service), unselected: !selectedServices.includes(service), disabled: !isEditing }]"
        @click="isEditing && toggleService(service)"
      >
        {{ service }}
      </span>
    </div>
  </div>
</div>




          <div class="form-group">
            <label>Business Website</label>
            <input
              type="url"
              v-model="businessWebsite"
              placeholder="https://yourbusiness.com"
              :disabled="!isEditing"
            />
          </div>

          <div class="form-group">
            <label>About</label>
            <textarea
              v-model="about"
              placeholder="Tell us about your business..."
              :disabled="!isEditing"
              class="about-textarea"
              rows="4"
            ></textarea>
          </div>

        </template>

        <!-- Mobile Number field: show for both individual and business -->
        <div class="form-group-number">
          <label>Mobile Number<span>*</span></label>
          <div class="mobile-input">
            <select v-model="selectedCountryCode" :disabled="!isEditing">
              <option v-for="code in countryCodes" :key="code" :value="code">
                {{ code }}
              </option>
            </select>
            <input
              type="text"
              v-model="mobile"
              placeholder="Enter Mobile Number"
              oninput="this.value=this.value.replace(/[^0-9]/g,'')"
              maxlength="10"
              :disabled="!isEditing"
            />
          </div>
          <div class="verification-controls" v-if="isEditing">
            <button
              type="button"
              class="verify-btn"
              :disabled="!mobile || phoneOtpSending"
              @click="sendPhoneOtp"
            >{{ phoneOtpSending ? 'Sending...' : (phoneVerified ? 'Re-verify Phone' : 'Verify Phone') }}</button>
            <div class="otp-inline" v-if="phoneOtpSent && !phoneVerified">
              <input
                type="text"
                v-model="phoneOtp"
                maxlength="6"
                placeholder="Enter 6-digit OTP"
              />
              <button
                type="button"
                class="verify-btn verify-btn--confirm"
                :disabled="phoneOtpVerifying || phoneOtp.length !== 6"
                @click="verifyPhoneOtp"
              >{{ phoneOtpVerifying ? 'Verifying...' : 'Confirm' }}</button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Email ID</label>
          <input
            type="email"
            v-model="email"
            placeholder="Enter Email Id"
            :disabled="!isEditing"
          />
          <div class="verification-controls" v-if="isEditing">
            <button
              type="button"
              class="verify-btn"
              :disabled="!email || emailOtpSending"
              @click="sendEmailOtp"
            >{{ emailOtpSending ? 'Sending...' : (emailVerified ? 'Re-verify Email' : 'Verify Email') }}</button>
            <div class="otp-inline" v-if="emailOtpSent && !emailVerified">
              <input
                type="text"
                v-model="emailOtp"
                maxlength="6"
                placeholder="Enter 6-digit OTP"
              />
              <button
                type="button"
                class="verify-btn verify-btn--confirm"
                :disabled="emailOtpVerifying || emailOtp.length !== 6"
                @click="verifyEmailOtp"
              >{{ emailOtpVerifying ? 'Verifying...' : 'Confirm' }}</button>
            </div>
          </div>
        </div>

          <div class="form-group">
          <label>Social Media Links</label>
          <div class="social-input-wrapper">
            <input
              type="url"
              v-model="socialLinkInput"
              placeholder="Enter social media URL"
              :disabled="!isEditing"
              class="social-input"
              @keyup.enter="addSocialLink"
            />
            <button type="button" class="add-social-btn" @click="addSocialLink" :disabled="!isEditing || !socialLinkInput">Add</button>
          </div>
          <div v-if="socialLinks.length > 0" class="social-links-list">
            <div v-for="(link, idx) in socialLinks" :key="link" class="social-link-row">
              <span class="social-icon">
                <span class="default-social-icon">🔗</span>
              </span>
              <a :href="link" target="_blank" rel="noopener" class="social-link-url">{{ link }}</a>
              <span class="delete-social-link" @click="removeSocialLink(idx)" title="Delete">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><path stroke="#B0B0B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M6 18L18 6"/></svg>
              </span>
            </div>
          </div>
        </div>

   

        <div class="form-group add-photo-section">
          <label>Profile Image</label>
          <div
            class="upload-section"
            :class="{ 'drag-active': dragOver, disabled: !isEditing }"
            @click="isEditing && triggerFileInput()"
            @dragover.prevent="isEditing && (dragOver = true)"
            @dragleave.prevent="dragOver = false"
            @drop.prevent="isEditing && handleDrop($event)"
          >
            <div>
<img :src="previewImageUrl || defaultImage" class="profile-pic" />

            </div>
            <div class="upload-box">
              <div class="upload-icon">
                <img src="../icons/uploadIcon.svg" alt="upload" />
              </div>
              <p>
                <span class="upload-link">Click to upload</span> or drag and drop
              </p>
              <p class="upload-hint">SVG, PNG, JPG or GIF (max. 800×400px)</p>
            </div>
          </div>
        </div>

        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept="image/*"
          @change="handleFileSelect"
        />


        <div class="form-group">
          <label>Preferred Country</label>
          <select v-model="preferredCountryName" :disabled="!isEditing">
            <option value="" disabled>Select a country</option>
            <option v-for="c in countries" :key="c" :value="c">
              {{ c }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Default Location</label>
          <div class="form-group" ref="locationBox" style="position: relative;">
            <input
              type="text"
              v-model="defaultLocation"
              placeholder="Enter your default location (e.g., New York, NY)"
              :disabled="!isEditing"
              @input="onLocationInput"
              @focus="showSuggestions = true"
            />
            <div
              v-if="showSuggestions && locationSuggestions.length > 0"
              class="suggestions-dropdown"
              :style="{ width: $refs.locationBox ? $refs.locationBox.offsetWidth + 'px' : '100%', top: ($refs.locationBox ? $refs.locationBox.offsetHeight + 'px' : '70px') }"
            >
              <div 
                v-for="(suggestion, index) in locationSuggestions" 
                :key="index"
                class="suggestion-item"
                @click="selectLocationSuggestion(suggestion)"
              >
                {{ suggestion.description }}
              </div>
            </div>
          </div>
        </div>


      </form>
        <!-- Sticky footer buttons — always visible when editing -->
        <div class="btn-group-sticky" v-if="isEditing">
          <button type="button" class="cancel-btn" @click="onCancel">Cancel</button>
          <button type="button" class="save-btn" @click="onSave">Save</button>
        </div>
      </div><!-- end profile-form-panel -->
    </div><!-- end profile-page-wrapper -->
    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import userDetailsService from "@/services/userDetailsService";
import api from "@/services/userDetailsService";
import defaultProfile from "../icons/Avatar.svg";
import Navigation from "./Navigation.vue";
import Footer from "./footer.vue";
import { toast } from "vue-sonner";
import { getNames as getCountryNames, getName as getCountryNameByCode } from "country-list";
import { getRecaptchaToken } from "@/utils/recaptcha";

export default {
  name: "DropdownProfileview",
  components: {
    Navigation,
    Footer,
  },
  data() {
    return {
      isEditing: false,
      showEdit: true,
      userData: [],
      userId: localStorage.getItem("userid"),
      username: "",
      userSlug: "",
      email: "",
      firstName: "",
      lastName: "",
      mobile: "",
      emailVerified: false,
      phoneVerified: false,
      emailOtp: "",
      phoneOtp: "",
      emailOtpSent: false,
      phoneOtpSent: false,
      emailOtpSending: false,
      phoneOtpSending: false,
      emailOtpVerifying: false,
      phoneOtpVerifying: false,
      preferredCountryName: "",
      // timezone: "",
      imageUrl: "",
      defaultImage: defaultProfile,
      dragOver: false,
      selectedFile: null,
      showSuggestions: false,
 businessName: "",
      servicesList: [
        "Rentals - Rooms Wanted",
        "Rentals - Rooms Offered",
        "Rentals - House Wanted",
        "Rentals - House Offered",
        "Rentals - Commercial Wanted",
        "Rentals - Commercial Offered",
        "Rentals - Apartments Wanted",
        "Rentals - Apartments Offered",
        "Services - Service Wanted",
        "Services - Service Offered",
        "Jobs - Jobs Wanted",
        "Jobs - Jobs Offered",
        "Sales - Cars",
        "Sales - Bikes",
        "Sales - Others",
        "Events - Shows",
        "Events - Movies",
        "Events - Sports",
        "Events - Others"
      ],
 selectedService: "",
selectedServices: [],


      businessWebsite: "",
        socialLinkInput: "",
        socialLinks: [],
     
      about: "",
      
      countries:[],
      countryCodes: [
        "+1",
        "+7",
        "+20",
        "+27",
        "+30",
        "+31",
        "+32",
        "+33",
        "+34",
        "+36",
        "+39",
        "+44",
        "+49",
        "+52",
        "+55",
        "+61",
        "+62",
        "+63",
        "+64",
        "+65",
        "+81",
        "+82",
        "+84",
        "+86",
        "+90",
        "+91",
        "+92",
        "+94",
        "+98",
      ],
      selectedCountryCode: "+1",
      defaultLocation: "",
      defaultLocationLat: null,
      defaultLocationLng: null,
      defaultLocationCity: "",
      locationSuggestions: [],
      locationDebounceTimer: null,
      accountType:"",
        subscriptionPlan: "free",
        subscriptionInfo: null,
        newServiceInput: "",
        previewImageUrl: "",
        savedImageUrl: "",
        locationCancelToken: null,
lastSearchedLocation: "",

      // Banner customization
      bannerColor: "linear-gradient(135deg, #ff6b35 0%, #ee5a24 35%, #f0932b 70%, #f8c291 100%)",
      bannerImage: "",           // saved banner image filename from DB
      bannerImageUrl: "",        // resolved blob URL for saved banner image
      bannerImagePreview: "",    // local preview URL for newly selected file
      bannerSelectedFile: null,  // the File object to upload
      bannerDragOver: false,
      bannerGradients: [
        { name: "Sunset Coral",  value: "linear-gradient(135deg, #ff6b35 0%, #ee5a24 35%, #f0932b 70%, #f8c291 100%)" },
        { name: "Ocean Blue",    value: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
        { name: "Fresh Green",   value: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)" },
        { name: "Berry Purple",  value: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)" },
        { name: "Warm Gold",     value: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)" },
        { name: "Midnight",      value: "linear-gradient(135deg, #232526 0%, #414345 100%)" },
        { name: "Rose Pink",     value: "linear-gradient(135deg, #ee9ca7 0%, #ffdde1 100%)" },
        { name: "Teal Dream",    value: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)" },
        { name: "Peach",         value: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)" },
        { name: "Sky Blue",      value: "linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)" },
      ],

   
    };
  },


  computed: {
    fullPhoneNumber() {
      return `${this.selectedCountryCode || ""}${this.mobile || ""}`.trim();
    },
    bannerPreviewStyle() {
      if (this.bannerImagePreview) {
        return { backgroundImage: `url(${this.bannerImagePreview})`, backgroundSize: 'cover', backgroundPosition: 'center' };
      }
      if (this.bannerImageUrl) {
        return { backgroundImage: `url(${this.bannerImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' };
      }
      return { background: this.bannerColor };
    },
  },
  created() {
    this.loadData();
    this.loadVerificationStatus();
    this.fetchusername();
    this.fetchProfilePicture();
    this.fetchSubscriptionInfo();
    this.countries = getCountryNames();
    axios.post("/api/getoneusers", {
      userID: localStorage.getItem("userid")
    })
    .then((response) => {
      // Set accountType to 'individual' or 'business'
      const userType = response.data[0]?.accountType;
      this.accountType = (userType === "business") ? "business" : "individual";
    });
  },
  mounted() {
            document.addEventListener("click", this.handleLocationClickOutside);
          },
          beforeUnmount() {
            document.removeEventListener("click", this.handleLocationClickOutside);
          },
         
 
  methods: {


       handleLocationClickOutside(event) {
              const locationBox = this.$refs.locationBox;
              if (locationBox && !locationBox.contains(event.target)) {
                this.showSuggestions = false;
              }
            },
               addCustomService() {
      const service = this.newServiceInput.trim();
      if (!service) return;
      if (this.servicesList.includes(service)) {
        if (!this.selectedServices.includes(service)) {
          this.selectedServices.push(service);
        }
        this.newServiceInput = "";
        return;
      }
      this.servicesList.push(service);
      this.selectedServices.push(service);
      this.newServiceInput = "";
    },  

    toggleService(service) {
      if (!this.isEditing) return;
      const idx = this.selectedServices.indexOf(service);
      if (idx === -1) {
        this.selectedServices.push(service);
      } else {
        this.selectedServices.splice(idx, 1);
      }
    },


    setAccountType(type) {
      if (!this.isEditing) return;
      if (this.accountType !== type) {
        this.accountType = type;
        if (type === 'individual') {
          this.businessName = '';
          this.selectedService = '';
          this.businessWebsite = '';
          this.about = '';
        }
        // Show toast for account type change
        if (type === 'business') {
          toast.success('Changed to Business Account');
        } else if (type === 'individual') {
          toast.success('Changed to Individual Account');
        }
      }
      axios.put("/api/updateoneuser", {
        userID: this.userId,
        accountType: this.accountType
      })
      .then(response => { 
        console.log("Account type updated successfully", response);
      });
    },

    addSocialLink() {
      if (!this.isEditing) return;
      const url = this.socialLinkInput.trim();
      if (!url) return;
      if (this.socialLinks.includes(url)) {
        toast.error("This link is already added");
        return;
      }
      this.socialLinks.push(url);
      this.socialLinkInput = "";
    },
    removeSocialLink(idx) {
      if (!this.isEditing) return;
      this.socialLinks.splice(idx, 1);
    },

    // ── Banner customization methods ──
    selectBannerColor(gradient) {
      if (!this.isEditing) return;
      this.bannerColor = gradient;
      // Clear any uploaded image when user picks a color
      this.bannerImagePreview = "";
      this.bannerSelectedFile = null;
      this.bannerImage = "";
      this.bannerImageUrl = "";
    },
    handleBannerFileSelect(event) {
      if (!this.isEditing) return;
      const file = event.target.files[0];
      this.processBannerFile(file);
    },
    handleBannerDrop(event) {
      if (!this.isEditing) return;
      this.bannerDragOver = false;
      const file = event.dataTransfer.files[0];
      this.processBannerFile(file);
    },
    processBannerFile(file) {
      if (!file) return;
      if (!file.type.startsWith("image/")) {
        toast.error("Please select an image file");
        return;
      }
      this.bannerSelectedFile = file;
      this.bannerImagePreview = URL.createObjectURL(file);
      // Clear color selection since user chose an image
      this.bannerImage = "";
    },
    removeBannerImage() {
      if (!this.isEditing) return;
      this.bannerImagePreview = "";
      this.bannerSelectedFile = null;
      this.bannerImage = "";
      this.bannerImageUrl = "";
      if (this.$refs.bannerFileInput) {
        this.$refs.bannerFileInput.value = "";
      }
    },
    async fetchBannerImageBlob(fileName) {
      if (!fileName) { this.bannerImageUrl = ""; return; }
      try {
        const res = await axios.post("/api/file/get", { fileName, albumName: "default" }, { responseType: "blob" });
        if (res.data && res.data.size > 0) {
          const contentType = res.data.type || res.headers["content-type"] || "image/jpeg";
          const blob = new Blob([res.data], { type: contentType });
          this.bannerImageUrl = URL.createObjectURL(blob);
        }
      } catch (err) {
        console.warn("Failed to load banner image:", err);
        this.bannerImageUrl = "";
      }
    },
    async uploadBannerImage() {
      if (!this.bannerSelectedFile) return "";
      try {
        const formData = new FormData();
        formData.append("profilePic", this.bannerSelectedFile);
        const uploadRes = await axios.post("/api/file/upload", formData);
        const uploadedFileName = uploadRes.data.files?.[0]?.filename || "";
        if (uploadedFileName) {
          this.bannerImage = uploadedFileName;
          // Hand the local blob URL over to bannerImageUrl so the preview
          // keeps rendering after save — the file we uploaded is the same
          // content the server now has, no need for an extra /file/get
          // round-trip just to redisplay it.
          if (this.bannerImagePreview) {
            this.bannerImageUrl = this.bannerImagePreview;
          }
          this.bannerImagePreview = "";
          this.bannerSelectedFile = null;
          if (this.$refs.bannerFileInput) {
            this.$refs.bannerFileInput.value = "";
          }
        }
        return uploadedFileName;
      } catch (err) {
        console.error("Banner image upload failed:", err);
        return "";
      }
    },
    fetchusername() {
      const userid = localStorage.getItem("userid");

      if (!userid) {
        this.username = "unknown";
        this.email = "unknown";
        return;
      }

      axios
        .post("/api/getoneusers", { userID: userid })
        .then((response) => {
          this.username = response.data[0]?.userName || "unknown";
          this.email = response.data[0]?.email || "unknown";
          this.userSlug = response.data[0]?.slug || "";
        })
        .catch(() => {
          this.username = "unknown";
          this.email = "unknown";
        });
    },

    onClickedit() {
      this.isEditing = true;
      this.showEdit = false;
    },

    async loadVerificationStatus() {
      try {
        const res = await userDetailsService.getVerificationStatus(this.userId);
        this.emailVerified = res?.data?.item?.emailVerified === true;
        this.phoneVerified = res?.data?.item?.phoneVerified === true;
      } catch (err) {
        if (import.meta.env.DEV) {
          console.warn("Failed to load verification status", err);
        }
      }
    },

    async sendEmailOtp() {
      if (!this.email) {
        toast.error("Please enter email first");
        return;
      }
      this.emailOtpSending = true;
      try {
        const recaptchaToken = await getRecaptchaToken('otp_send');
        await axios.post("/api/sendotp", { email: this.email, recaptchaToken });
        this.emailOtpSent = true;
        this.emailOtp = "";
        toast.success("Email OTP sent");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to send email OTP");
      } finally {
        this.emailOtpSending = false;
      }
    },

    async verifyEmailOtp() {
      if (this.emailOtp.length !== 6) {
        toast.error("Enter a valid 6-digit OTP");
        return;
      }
      this.emailOtpVerifying = true;
      try {
        await axios.post("/api/verifyotp", {
          email: this.email,
          otp: this.emailOtp,
          userID: this.userId,
        });
        this.emailVerified = true;
        this.emailOtpSent = false;
        this.emailOtp = "";
        toast.success("Email verified successfully");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Email OTP verification failed");
      } finally {
        this.emailOtpVerifying = false;
      }
    },

    async sendPhoneOtp() {
      if (!this.mobile) {
        toast.error("Please enter phone number first");
        return;
      }
      this.phoneOtpSending = true;
      try {
        await axios.post("/api/sms/send-otp", { phoneNumber: this.fullPhoneNumber });
        this.phoneOtpSent = true;
        this.phoneOtp = "";
        toast.success("Phone OTP sent");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to send phone OTP");
      } finally {
        this.phoneOtpSending = false;
      }
    },

    async verifyPhoneOtp() {
      if (this.phoneOtp.length !== 6) {
        toast.error("Enter a valid 6-digit OTP");
        return;
      }
      this.phoneOtpVerifying = true;
      try {
        await axios.post("/api/sms/verify-otp", {
          phoneNumber: this.fullPhoneNumber,
          otp: this.phoneOtp,
          userID: this.userId,
        });
        this.phoneVerified = true;
        this.phoneOtpSent = false;
        this.phoneOtp = "";
        toast.success("Phone verified successfully");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Phone OTP verification failed");
      } finally {
        this.phoneOtpVerifying = false;
      }
    },

   onCancel() {
  this.isEditing = false;
  this.showEdit = true;

  this.previewImageUrl = "";
  this.selectedFile = null;

  if (this.$refs.fileInput) {
    this.$refs.fileInput.value = "";
  }

  this.emailOtp = "";
  this.phoneOtp = "";
  this.emailOtpSent = false;
  this.phoneOtpSent = false;
},


    // onLocationInput() {
    //   if (this.locationDebounceTimer) {
    //     clearTimeout(this.locationDebounceTimer);
    //   }
      
    //   this.locationDebounceTimer = setTimeout(() => {
    //     if (this.defaultLocation.length > 2) {
    //       this.fetchLocationSuggestions();
    //     } else {
    //       this.locationSuggestions = [];
    //     }
    //   }, 100);
    // },
    onLocationInput() {
  if (!this.defaultLocation || this.defaultLocation.length < 3) {
    this.locationSuggestions = [];
    return;
  }

  clearTimeout(this.locationDebounceTimer);

  this.locationDebounceTimer = setTimeout(() => {
    if (this.defaultLocation !== this.lastSearchedLocation) {
      this.fetchLocationSuggestions();
    }
  }, 100); // slightly higher debounce for smoother UX
},


    // async fetchLocationSuggestions() {
    //   try {
    //     const response = await axios.post("/api/places/autocomplete", {
    //       input: this.defaultLocation,
    //     });
    //     this.locationSuggestions = response.data || [];
    //   } catch (error) {
    //     console.error("Error fetching location suggestions:", error);
    //     this.locationSuggestions = [];
    //   }
    // },

async fetchLocationSuggestions() {
  try {
    // Cancel previous request if still running
    if (this.locationCancelToken) {
      this.locationCancelToken.cancel("New request started");
    }

    this.locationCancelToken = axios.CancelToken.source();
    this.lastSearchedLocation = this.defaultLocation;

    const response = await axios.post(
      "/api/places/autocomplete",
      { input: this.defaultLocation },
      { cancelToken: this.locationCancelToken.token }
    );

    this.locationSuggestions = response.data || [];
    // Always show suggestions if results exist
    this.showSuggestions = Array.isArray(this.locationSuggestions) && this.locationSuggestions.length > 0;
  } catch (error) {
    if (!axios.isCancel(error)) {
      console.error("Location fetch error:", error);
      this.locationSuggestions = [];
      this.showSuggestions = false;
    }
  }
},


    async selectLocationSuggestion(suggestion) {
      this.defaultLocation = suggestion.description;
      this.locationSuggestions = [];
      this.showSuggestions = false;
      console.log("Selected suggestion:", suggestion.place_id);
      // Get lat/lng for the selected location
      try {
        const response = await axios.post("/api/placedetails", {
          placeId: suggestion.place_id,
        });
        if (response.data) {
          // /api/placedetails returns flat { lat, lng }; the legacy Google path
          // returned response.data.result.geometry.location.* — handle both.
          const nested = response.data.result?.geometry?.location;
          this.defaultLocationLat = nested?.lat ?? response.data.lat ?? 0;
          this.defaultLocationLng = nested?.lng ?? response.data.lng ?? 0;
          this.defaultLocationCity = response.data.city || suggestion.description.split(',')[0];
        }
        console.log("Location details", response.data);
      } catch (error) {
        console.error("Error getting location details:", error);
      }
    },

    triggerFileInput() {
          if (!this.isEditing) return;
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
          if (!this.isEditing) return;
      const file = event.target.files[0];
      this.processFile(file);
    },

    handleDrop(event) {
          if (!this.isEditing) return;
      this.dragOver = false;
      const file = event.dataTransfer.files[0];
      this.processFile(file);
    },

    processFile(file) {
  if (!file) return;
  this.selectedFile = file;
  this.previewImageUrl = URL.createObjectURL(file); // ONLY form preview
},


    async loadData() {
      const res = await userDetailsService.getUserDetails({
        userID: this.userId,
      });

      this.userData = res.data;
      console.log("User details response:", res.data);
      this.firstName = res.data.items[0].firstName;
      this.lastName = res.data.items[0].lastName;
      this.email = res.data.items[0].Email;
      this.mobile = res.data.items[0].phoneNumber;
      this.emailVerified = res.data.items[0].emailVerified === true;
      this.phoneVerified = res.data.items[0].phoneVerified === true;
      // Ensure preferredCountryName matches dropdown
      let backendCountry = res.data.items[0].preferredCountryName || "";
      // If not found in countries, try to get from code
      if (!this.countries.includes(backendCountry)) {
        const code = res.data.items[0].preferredCountry || "";
        if (code) {
          const nameFromCode = getCountryNameByCode(code);
          if (nameFromCode && this.countries.includes(nameFromCode)) {
            backendCountry = nameFromCode;
          }
        }
      }
      this.preferredCountryName = this.countries.includes(backendCountry) ? backendCountry : "";
      this.defaultLocation = res.data.items[0].defaultLocation || "";
      this.defaultLocationLat = res.data.items[0].defaultLocationLat || null;
      this.defaultLocationLng = res.data.items[0].defaultLocationLng || null;
      this.defaultLocationCity = res.data.items[0].defaultLocationCity || "";
      // Business profile fields (populate if available)
      this.businessName = res.data.items[0].businessName || "";
      // Handle services as array for pills
      const servicesRaw = res.data.items[0].services || "";
      if (Array.isArray(servicesRaw)) {
        this.selectedServices = servicesRaw;
      } else if (typeof servicesRaw === 'string' && servicesRaw.length > 0) {
        this.selectedServices = servicesRaw.split(',').map(s => s.trim()).filter(Boolean);
      } else {
        this.selectedServices = [];
      }
      this.selectedService = "";
      this.businessWebsite = res.data.items[0].businessWebsite || "";
      this.about = res.data.items[0].about || "";

      // Social links: support both legacy (facebook) and new (socialLinks)
        if (Array.isArray(res.data.items[0].socialLinks)) {
          this.socialLinks = res.data.items[0].socialLinks;
        } else if (res.data.items[0].facebook) {
          this.socialLinks = [res.data.items[0].facebook];
        } else {
          this.socialLinks = [];
        }

      // Banner customization
      if (res.data.items[0].bannerColor) {
        this.bannerColor = res.data.items[0].bannerColor;
      }
      if (res.data.items[0].bannerImage) {
        this.bannerImage = res.data.items[0].bannerImage;
        this.fetchBannerImageBlob(this.bannerImage);
      }

      await this.loadVerificationStatus();
    },

    // async uploadProfileImage() {
    //   if (!this.selectedFile) {
    //     return; // No image selected → skip upload
    //   }
    //   const formData = new FormData();
    //   formData.append("profilePic", this.selectedFile);
    //   // Check if user already has an image
    //   const existingImageRes = await axios.post("/api/imagelist", {
    //     userID: this.userId,
    //   });
    //   const existingImage = existingImageRes.data.items[0];
    //   let uploadedFileName = "";
    //   // Upload file
    //   const uploadRes = await axios.post(
    //     "/api/file/upload", // <-- use /api/file/upload
    //     formData
    //   );
    //   if (import.meta.env.DEV) {
    //     console.log("image upload file Name", uploadRes.data.files?.[0]?.filename);
    //   }
    //   uploadedFileName = uploadRes.data.files?.[0]?.filename;
    //   // Update or insert
    //   if (uploadedFileName) {
    //     if (existingImage) {
    //       await axios.put("/api/editimage", {
    //         imageId: existingImage.imageId,
    //         userID: this.userId,
    //         filepath: uploadedFileName,
    //       });
    //     } else {
    //       await axios.post("/api/image", {
    //         userID: this.userId,
    //         filepath: uploadedFileName,
    //       });
    //     }
    //   }
    //   return;
    // },
async uploadProfileImage() {
  if (!this.selectedFile) {
    return; // No image selected → skip upload
  }

  try {
    const formData = new FormData();
    formData.append("profilePic", this.selectedFile);

    // Check if user already has an image
    const existingImageRes = await axios.post("/api/imagelist", {
      userID: this.userId,
    });

    const existingImage = existingImageRes.data.items?.[0];
    let uploadedFileName = "";

    // Upload file
    const uploadRes = await axios.post("/api/file/upload", formData);

    if (import.meta.env.DEV) {
      console.log("image upload file Name", uploadRes.data.files?.[0]?.filename);
    }

    uploadedFileName = uploadRes.data.files?.[0]?.filename;

    // Update or insert DB record
    if (uploadedFileName) {
      if (existingImage) {
        await axios.put("/api/editimage", {
          imageId: existingImage.imageId,
          userID: this.userId,
          filepath: uploadedFileName,
        });
      } else {
        await axios.post("/api/image", {
          userID: this.userId,
          filepath: uploadedFileName,
        });
      }

      // ✅ IMPORTANT: Update top profile image ONLY AFTER SUCCESS
      this.savedImageUrl = this.previewImageUrl;

      // Clear preview + selected file
      this.previewImageUrl = "";
      this.selectedFile = null;
        // ✅ Reset file input (VERY IMPORTANT)
  if (this.$refs.fileInput) {
    this.$refs.fileInput.value = "";
  }
    }
  } catch (error) {
    console.error("Image upload failed:", error);
    // toast.error("Image upload failed ❌");
  }
},


  
    async onSave() {
  try {
    const checkUser = await axios.post("/api/userdetailslist", {
      userID: this.userId,
    });

    const userDetails = checkUser.data?.items?.[0];
    const servicesString = this.selectedServices.join(",");

    let preferredCountryCode = "";
    if (this.preferredCountryName) {
      try {
        const { getCode } = await import("country-list");
        preferredCountryCode = getCode(this.preferredCountryName) || "";
      } catch (e) {
        preferredCountryCode = "";
      }
    }

    // Upload banner image if a new one was selected
    let bannerImageFilename = this.bannerImage || "";
    if (this.bannerSelectedFile) {
      const uploaded = await this.uploadBannerImage();
      if (uploaded) bannerImageFilename = uploaded;
    }

    const payload = {
      firstName: this.firstName,
      lastName: this.lastName,
      phoneNumber: this.mobile,
      preferredCountryName: this.preferredCountryName,
      preferredCountry: preferredCountryCode,
      userID: this.userId,
      Email: this.email,
      businessName: this.businessName,
      services: servicesString,
      businessWebsite: this.businessWebsite,
      defaultLocation: this.defaultLocation,
      defaultLocationLat: this.defaultLocationLat,
      defaultLocationLng: this.defaultLocationLng,
      defaultLocationCity: this.defaultLocationCity,
      socialLinks: this.socialLinks,
      about: this.about,
      bannerColor: this.bannerColor,
      bannerImage: bannerImageFilename,
    };

    if (!userDetails) {
      await axios.post("/api/adduserdetails", payload);
      toast.success("Profile Created Successfully 🎉");
    } else {
          await axios.put("/api/updateuserdetails", {
            userDetailsID: userDetails.userDetailsID,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.mobile,
            preferredCountryName: this.preferredCountryName,
            preferredCountry: preferredCountryCode,
            userID: this.userId,
            Email: this.email,
            defaultLocation: this.defaultLocation,
            defaultLocationLat: this.defaultLocationLat,
            defaultLocationLng: this.defaultLocationLng,
            defaultLocationCity: this.defaultLocationCity,
            businessName: this.businessName,
            services: servicesString,
            businessWebsite: this.businessWebsite,
            socialLinks: this.socialLinks,
            about: this.about,
            bannerColor: this.bannerColor,
            bannerImage: bannerImageFilename,
          });
          
          toast.success("Profile Updated Successfully ✨");
          // window.location.reload();
        }

    // Upload image separately
    try {
      await this.uploadProfileImage();
    } catch (err) {
      console.error("Image upload failed:", err);
    }

    await this.loadVerificationStatus();
    this.emailOtpSent = false;
    this.phoneOtpSent = false;
    this.emailOtp = "";
    this.phoneOtp = "";

    this.isEditing = false;
    this.showEdit = true;

  } catch (error) {
    console.error("API error:", error);
    toast.error("Failed to update profile ❌");
  }
},

    async fetchProfilePicture() {
      const url = await api.getProfileImage(this.userId);

    if (url) {
  this.savedImageUrl = url;
}
 else {
        if (import.meta.env.DEV) {
          console.log("No profile image found.");
        }
      }
    },

    // ── Subscription methods ──
    async fetchSubscriptionInfo() {
      const token = localStorage.getItem("auth-token");
      if (!token) {
        this.subscriptionPlan = "free";
        this.subscriptionInfo = null;
        return;
      }

      try {
        // Handle Stripe callback parameters
        const params = new URLSearchParams(window.location.search);
        const subscriptionState = params.get("subscription");
        
        // After Stripe redirect, wait for sync so status reflects latest plan.
        if (subscriptionState === "success" || subscriptionState === "canceled") {
          try {
            await axios.post("/api/subscription/sync", {}, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true,
              timeout: 8000,
            });
          } catch (err) {
            console.log("Subscription sync skipped (will retry on refresh):", err.message);
          }
          
          // Clean up URL params immediately
          const url = new URL(window.location);
          url.searchParams.delete("subscription");
          window.history.replaceState({}, "", url);
        }

        // Load current subscription status (this endpoint should be fast)
        console.log("Fetching subscription status...");
        const res = await axios.get("/api/subscription/status", {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
          timeout: 6000,
        });
        
        if (res.data) {
          console.log("Subscription status loaded:", res.data.plan);
          this.subscriptionPlan = res.data.plan || "free";
          this.subscriptionInfo = res.data;
        }
      } catch (err) {
        console.error("Failed to fetch subscription info:", err.message);
        // Gracefully degrade - show free plan if fetch fails
        if (!this.subscriptionPlan) {
          this.subscriptionPlan = "free";
        }
        if (!this.subscriptionInfo) {
          this.subscriptionInfo = null;
        }
      }
    },
    goToPricing() {
      this.$router.push("/pricing");
    },
    formatPeriodEnd(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    },
    async manageSubscription() {
      try {
        const token = localStorage.getItem("auth-token");
        if (!token) {
          toast.error("Please sign in to manage your subscription.");
          return;
        }
        const res = await axios.post(
          "/api/subscription/create-portal",
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );
        if (res.data.url) {
          window.location.href = res.data.url;
        }
      } catch (err) {
        toast.error("Failed to open subscription management.");
        console.error("Manage subscription error:", err);
      }
    },
  },
}
</script>

<style scoped>

/* ─── Page Layout ─────────────────────────────────────────────────── */
.profile-page-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 28px;
  max-width: 1200px;
  margin: 40px auto 60px;
  padding: 0 24px;
}

/* ─── Left Sidebar ────────────────────────────────────────────────── */
.profile-sidebar {
  width: 280px;
  min-width: 260px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e8ecf0;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  position: sticky;
  top: 80px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.sidebar-avatar-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.avatar-container {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  flex-shrink: 0;
}

.avatar-container.editable {
  cursor: pointer;
}

.sidebar-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid #e6ecfa;
  object-fit: cover;
  display: block;
}

.avatar-edit-overlay {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
  background: #3467d5;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: background 0.15s ease;
}

.avatar-container.editable:hover .avatar-edit-overlay {
  background: #2554c7;
}

.avatar-container.editable:hover .sidebar-avatar {
  opacity: 0.85;
}

.sidebar-username {
  font-size: 18px;
  font-weight: 700;
  color: #181d27;
  margin: 0;
  line-height: 1.3;
}
.sidebar-username--link {
  text-decoration: none;
  color: #181d27;
  transition: color 0.2s;
}
.sidebar-username--link:hover {
  color: #0d9488;
  text-decoration: underline;
}

.sidebar-account-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  background: #e6ecfa;
  color: #3467d5;
}

.sidebar-account-badge.business {
  background: #fef3c7;
  color: #d97706;
}

.sidebar-info-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid #f0f2f5;
  padding-top: 16px;
}

.sidebar-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.4;
  word-break: break-word;
}

.sidebar-info-item svg {
  flex-shrink: 0;
}

.contact-line {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.verification-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.verification-badge.verified {
  background: #dcfce7;
  color: #166534;
}

.verification-badge.unverified {
  background: #fef2f2;
  color: #b91c1c;
}

.sidebar-edit-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  justify-content: center;
  background: #3467d5;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-primary, "Inter", sans-serif);
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 4px;
}

.sidebar-edit-btn:hover {
  background: #2554c7;
}
.sidebar-view-profile-link {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  justify-content: center;
  background: transparent;
  color: #e8573d;
  border: 1.5px solid #e8573d;
  border-radius: 10px;
  padding: 10px 20px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-primary, "Inter", sans-serif);
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
  box-sizing: border-box;
}
.sidebar-view-profile-link:hover {
  background: #e8573d;
  color: #fff;
}
.sidebar-view-profile-link:hover svg {
  stroke: #fff;
}

/* ─── Subscription Plan Section ──────────────────────────────────── */
.sidebar-plan-section {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #e8ecf0;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-plan-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}

.sidebar-plan-badge-row {
  display: flex;
  align-items: center;
}

.sidebar-plan-badge {
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 8px;
}

.plan--free {
  background: #f0fdf4;
  color: #16a34a;
}

.plan--premium {
  background: #eff6ff;
  color: #3467d5;
}

.plan--business {
  background: #f1f5f9;
  color: #334155;
}

.sidebar-plan-usage {
  font-size: 12px;
  color: #6b7280;
}

.sidebar-plan-cancel-notice {
  font-size: 12px;
  color: #d97706;
  margin-top: 4px;
  font-weight: 500;
}

.sidebar-upgrade-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  background: linear-gradient(135deg, #3467d5, #5b8def);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: var(--font-primary, "Inter", sans-serif);
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 4px;
}

.sidebar-upgrade-btn:hover {
  opacity: 0.9;
}

.sidebar-manage-btn {
  width: 100%;
  background: transparent;
  color: #3467d5;
  border: 1.5px solid #3467d5;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: var(--font-primary, "Inter", sans-serif);
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  margin-top: 4px;
}

.sidebar-manage-btn:hover {
  background: #3467d5;
  color: #fff;
}

.sidebar-analytics-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 500;
  color: #3467d5;
  text-decoration: none;
  transition: color 0.15s;
}

.sidebar-analytics-link:hover {
  color: #2857c0;
}

/* ─── Right Form Panel ────────────────────────────────────────────── */
.profile-form-panel {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e8ecf0;
  padding: 36px 40px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}

/* Edit mode panel styling */
.profile-form-panel.is-editing {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52, 103, 213, 0.08), 0 2px 8px rgba(0,0,0,0.06);
  padding-bottom: 0;
  /* Do NOT cap the panel height / clip it here. The panel sits in normal page
     flow (~116px below the viewport top: 76px navbar + 40px wrapper margin), so
     a `max-height: calc(100vh - 120px)` + `overflow: hidden` turned it into a
     fixed-height internal scroller that fought the page scroll: the sticky left
     sidebar scrolled fully while the right panel's lower fields and the sticky
     Save bar were pushed below the fold and hidden. Let the whole page scroll
     instead — the Save bar stays pinned via `position: sticky; bottom: 0`. */
}

.form-panel-header {
  margin-bottom: 28px;
  padding-bottom: 18px;
  border-bottom: 1px solid #f0f2f5;
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.form-panel-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #181d27;
  margin: 0 0 4px;
  width: 100%;
}

.form-panel-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.edit-mode-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #3467d5;
  background: #eef2ff;
  border-radius: 20px;
  letter-spacing: 0.02em;
}

/* ─── Form Elements ───────────────────────────────────────────────── */
.profile-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-form.form-scrollable {
  /* No internal scroll — the form grows with its content and the page scrolls.
     (Previously `flex: 1; overflow-y: auto` against the capped panel above,
     which clipped the lower fields.) */
  padding-right: 8px;
  padding-bottom: 8px;
}

.profile-form.form-scrollable::-webkit-scrollbar {
  width: 5px;
}

.profile-form.form-scrollable::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 4px;
}

.profile-form.form-scrollable::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.row {
  display: flex;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  margin-bottom: 0;
}

.form-group-name {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.form-group-number {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.form-group label,
.form-group-name label,
.form-group-number label {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  margin-bottom: 6px;
  line-height: 20px;
}

.form-group input,
.form-group-name input,
.form-group-number input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  font-family: "Inter", sans-serif;
  color: #101828;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group-name input:focus,
.form-group-number input:focus {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52, 103, 213, 0.1);
}

.form-group input:disabled,
.form-group-name input:disabled,
.form-group-number input:disabled {
  background: transparent;
  color: #181d27;
  border-color: transparent;
  cursor: default;
  padding-left: 0;
  font-weight: 500;
}

/* Enabled inputs in edit mode */
.is-editing .form-group input:not(:disabled),
.is-editing .form-group-name input:not(:disabled),
.is-editing .form-group-number input:not(:disabled) {
  background: #fff;
  border-color: #d0d5dd;
}

.form-group select {
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  padding-right: 40px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  color: #344054;
  background-color: white;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("../icons/down-arrow.svg");
  background-repeat: no-repeat;
  background-position: right 14px center;
  background-size: 16px;
  outline: none;
  transition: border-color 0.2s;
}

.form-group select:focus {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52, 103, 213, 0.1);
}

.form-group select:disabled {
  background-color: transparent;
  color: #181d27;
  border-color: transparent;
  cursor: default;
  padding-left: 0;
  font-weight: 500;
  background-image: none;
}

/* ─── Account Type Toggle ─────────────────────────────────────────── */
.account-type-toggle-simple {
  display: flex;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e0e4ea;
  background: #f8fafc;
}

.toggle-simple {
  flex: 1 1 0;
  background: transparent;
  color: #344054;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: 600;
  height: 42px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  border-radius: 0;
  position: relative;
  letter-spacing: 0.01em;
  font-family: "Inter", sans-serif;
}

.toggle-simple.active {
  background: #cee2f9;
  color: #0f53e7;
  font-weight: 700;
  z-index: 1;
  box-shadow: 0 1px 6px rgba(37,99,235,0.08);
}

.toggle-simple:not(:last-child) {
  border-right: 1px solid #e0e4ea;
}

/* ─── Services Pills ──────────────────────────────────────────────── */
.services-box {
  border: 1.5px solid #e0e4ea;
  border-radius: 12px;
  padding: 16px 12px;
  margin-top: 6px;
}

.all-services-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.service-pill {
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border: 1px solid #d1d5db;
  background: #f1f5f9;
  color: #374151;
  transition: background 0.18s, color 0.18s, border 0.18s;
  user-select: none;
  font-family: "Inter", sans-serif;
}

.service-pill.selected {
  background: #cee2f9;
  color: #0f53e7;
  border: 1.5px solid #cee2f9;
  font-weight: 600;
}

.service-pill.unselected {
  background: #f1f5f9;
  color: #374151;
  border: 1px solid #d1d5db;
}

.service-pill.disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* ─── Mobile Number ───────────────────────────────────────────────── */
.mobile-input {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-input select {
  padding: 10px 8px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  font-family: "Inter", sans-serif;
  background: #fff;
  min-width: 80px;
}

.mobile-input select:focus {
  border-color: #3467d5;
}

.verification-controls {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.verify-btn {
  width: fit-content;
  border: 1px solid #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  cursor: pointer;
}

.verify-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.verify-btn--confirm {
  background: #2563eb;
  color: #fff;
}

.otp-inline {
  display: flex;
  gap: 8px;
  align-items: center;
}

.otp-inline input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  max-width: 170px;
}

/* ─── About Textarea ──────────────────────────────────────────────── */
.about-textarea {
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s;
  color: #101828;
  box-sizing: border-box;
}

.about-textarea:focus {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52, 103, 213, 0.1);
}

.about-textarea:disabled {
  background: transparent;
  color: #181d27;
  border-color: transparent;
  cursor: default;
  padding-left: 0;
  font-weight: 500;
  resize: none;
}

/* ─── Profile Image Upload ────────────────────────────────────────── */
.add-photo-section {
  margin-top: 4px;
}

.upload-section {
  display: flex;
  gap: 16px;
  cursor: pointer;
}

.upload-section.disabled {
  cursor: default;
}

.upload-section.drag-active {
  border-color: #3467d5;
  background: #f3f6ff;
}

.profile-pic {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e6ecfa;
  flex-shrink: 0;
}

.upload-box {
  border: 1px dashed #d0d5dd;
  border-radius: 8px;
  padding: 14px 16px;
  flex: 1;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
  background: #fafafa;
}

.upload-box:hover {
  border-color: #3467d5;
  background: #f0f5ff;
}

.upload-icon {
  margin-bottom: 6px;
}

.upload-icon img {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}

.upload-box p {
  font-size: 13px;
  color: #555;
  margin: 0;
}

.upload-link {
  color: #3467d5;
  cursor: pointer;
  font-weight: 600;
}

.upload-hint {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px !important;
}

/* ─── Social Links ────────────────────────────────────────────────── */
.social-input-wrapper {
  position: relative;
  width: 100%;
}

.social-input {
  width: 100%;
  box-sizing: border-box;
  padding-right: 70px;
}

.add-social-btn {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  height: 32px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid #3467d5;
  background: #3467d5;
  color: white;
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  font-weight: 600;
  transition: background 0.2s;
}

.add-social-btn:hover:not(:disabled) {
  background: #2554c7;
}

.add-social-btn:disabled {
  background: #b3c6f7;
  border-color: #b3c6f7;
  cursor: not-allowed;
}

.social-links-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.social-link-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.social-link-row:hover {
  background: #f1f5f9;
  border-color: #c7d2fe;
}

.social-icon {
  width: 32px;
  height: 32px;
  background: #eef2ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.social-link-url {
  flex: 1;
  font-size: 13px;
  color: #1f2937;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.social-link-url:hover {
  text-decoration: underline;
}

.delete-social-link {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.delete-social-link:hover {
  background: #fee2e2;
}

/* ─── Location Suggestions ────────────────────────────────────────── */
.suggestions-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  width: 100%;
  box-sizing: border-box;
}

.suggestion-item {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #414651;
  border-bottom: 1px solid #f3f4f6;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background: #f5f7ff;
}

/* ─── Save/Cancel Buttons (sticky footer) ────────────────────────── */
.btn-group-sticky {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid #e8ecf0;
  background: #fff;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 5;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  color: #414651;
  font-family: var(--font-primary, "Inter", sans-serif);
  font-weight: 600;
  line-height: 20px;
  transition: background 0.2s;
}

.cancel-btn:hover {
  background: #f9fafb;
}

.save-btn {
  background: #3467d5;
  color: white;
  border: 1px solid #3467d5;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  cursor: pointer;
  font-family: var(--font-primary, "Inter", sans-serif);
  font-weight: 600;
  line-height: 20px;
  transition: background 0.2s;
}

.save-btn:hover {
  background: #2554c7;
}

/* ─── Banner Customization ────────────────────────────────────────── */
.banner-hint {
  font-size: 13px;
  color: #9b8e82;
  margin: 0 0 12px;
}

.banner-preview {
  width: 100%;
  height: 100px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-preview-pattern {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(255,255,255,0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255,255,255,0.06) 0%, transparent 40%);
}

.banner-preview-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  text-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

.banner-section-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #636e72;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.banner-color-section {
  margin-bottom: 16px;
}

.banner-color-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.banner-color-swatch {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.banner-color-swatch:hover:not(:disabled) {
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(0,0,0,0.15);
}

.banner-color-swatch.selected {
  border-color: #2d3436;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #2d3436;
}

.banner-color-swatch:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.banner-upload-section {
  margin-bottom: 4px;
}

.banner-upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px;
  border: 2px dashed #e0dbd2;
  border-radius: 10px;
  background: #faf9f7;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.banner-upload-zone:hover:not(.disabled) {
  border-color: #e8573d;
  background: #fff3ee;
}

.banner-upload-zone.drag-active {
  border-color: #e8573d;
  background: #fff3ee;
}

.banner-upload-zone.disabled {
  cursor: default;
  opacity: 0.6;
}

.banner-upload-zone span {
  font-size: 13px;
  color: #636e72;
}

.banner-upload-hint {
  font-size: 11px !important;
  color: #b0a89e !important;
}

.banner-remove-btn {
  margin-top: 8px;
  background: none;
  border: 1px solid #e0dbd2;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  color: #c44;
  cursor: pointer;
  transition: all 0.15s;
}

.banner-remove-btn:hover:not(:disabled) {
  background: #fff0f0;
  border-color: #c44;
}

.banner-remove-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Responsive ──────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .profile-page-wrapper {
    flex-direction: column;
    gap: 20px;
    margin: 24px auto 40px;
    padding: 0 16px;
  }

  .profile-sidebar {
    width: 100%;
    min-width: unset;
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 20px 20px;
    gap: 16px;
  }

  .sidebar-avatar-wrap {
    flex-direction: row;
    text-align: left;
    gap: 14px;
    align-items: center;
    flex: 1;
    min-width: 220px;
  }

  .sidebar-avatar {
    width: 72px;
    height: 72px;
  }

  .sidebar-info-list {
    border-top: none;
    padding-top: 0;
    border-left: 1px solid #f0f2f5;
    padding-left: 16px;
    flex: 2;
    min-width: 180px;
  }

  .sidebar-edit-btn {
    width: auto;
    align-self: center;
  }

  .profile-form-panel {
    padding: 24px 20px;
  }
}

@media (max-width: 600px) {
  .profile-sidebar {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px 16px;
  }

  .sidebar-avatar-wrap {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
  }

  .avatar-container {
    width: 88px;
    height: 88px;
  }

  .sidebar-avatar {
    width: 88px;
    height: 88px;
    border-width: 3px;
  }

  .sidebar-username {
    font-size: 16px;
    margin: 0;
  }

  .sidebar-info-list {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #f0f2f5;
    padding-top: 12px;
    width: 100%;
    align-items: flex-start;
  }

  .sidebar-edit-btn {
    width: 100%;
  }

  .profile-form-panel {
    padding: 20px 16px;
  }

  .row {
    flex-direction: column;
  }

  .otp-inline {
    flex-direction: column;
    align-items: stretch;
  }

  .verify-btn,
  .otp-inline input {
    width: 100%;
    max-width: none;
  }

  .btn-group-sticky {
    flex-direction: column;
    padding: 12px 0;
    /* Stick above the fixed bottom tab bar (48px + home-indicator inset)
       instead of behind it. */
    bottom: calc(48px + env(safe-area-inset-bottom, 0px));
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
    justify-content: center;
    text-align: center;
  }

  .profile-form-panel.is-editing {
    max-height: none;
  }
}
</style>


